import { motion } from "framer-motion";
import { Coins, Landmark, AlertTriangle, HardHat, FileText, ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/shared";
import { DIFFERENTIATORS } from "@/data/content";

const ICONS = [Coins, Landmark, AlertTriangle, HardHat, FileText, ShieldCheck];

export default function WhyChoose() {
  return (
    <section id="diferenciais" className="grain relative scroll-mt-20 overflow-hidden bg-navy-900 py-24 lg:py-32">
      <div className="pointer-events-none absolute right-0 top-0 h-[500px] w-[500px] rounded-full bg-gold/[0.06] blur-[140px]" />
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Diferenciais"
          title={<>Por que escolher <span className="text-gold-grad">a Realiza?</span></>}
          sub="Engenharia aplicada à gestão do seu condomínio — com método, documento e responsabilidade técnica."
        />
        <div className="mt-16 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {DIFFERENTIATORS.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={(i % 3) * 0.08}>
                <div className="group h-full border-l-2 border-gold/25 bg-white/[0.03] p-7 transition-all duration-500 hover:border-gold hover:bg-white/[0.05]">
                  <motion.span
                    whileHover={{ rotate: -8, scale: 1.1 }}
                    transition={{ type: "spring", stiffness: 300 }}
                    className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 bg-gold/10 text-gold"
                  >
                    <Icon className="h-5 w-5" strokeWidth={1.6} />
                  </motion.span>
                  <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-wide text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
